import { CollectionViewer } from '@angular/cdk/collections';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FolderService } from 'src/app/acl-data/folder/folder.service';

export class FilenetNestedDataSource<Folder> extends MatTreeNestedDataSource<
    Folder
> {
    constructor(
        private folderService: FolderService,
        private objectStore: string
    ) {
        super();
    }

    connect(collectionViewer: CollectionViewer): Observable<Folder[]> {
        // console.log('CONNECTING');
        return (this.folderService.getRoot(this.objectStore).pipe(
            // tap(v => console.log('GOT ROOT', v)),
            map(v =>
                v.sort((a, b) =>
                    a.propertiesObj.FolderName > b.propertiesObj.FolderName
                        ? 1
                        : -1
                )
            )
        ) as unknown) as Observable<Folder[]>;
        // .pipe(
        //   switchMap(rootFolder =>
        //     this.folderService.displayByIds(this.objectStore, rootFolder.subFolders)
        //   )
        // );
    }

    disconnect() {
        // no op
    }
}
